<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      z-index="51001"
      title="View submission"
      right
      shadow
      :visible="active"
      backdrop
      no-header
      sidebar-class="sidebar-lg"
      header-class="header-dark"
      bg-variant="white"
      @change="(val) => $emit('update:active', val)"
      width="420px"
    >
      <!-- @hidden="clearForm" -->
      <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

      <template #default="{ hide }" v-if="submission">
        <!-- Header -->
        <div
          class="
            header-dark
            d-flex
            justify-content-between
            align-items-center
            content-sidebar-header
            px-4
            py-3
          "
        >
          <b-button size="sm" variant="outline-success disabled rounded-lg">
            {{ "Submitted" }}
          </b-button>

          <!--   <h5 v-else class="mb-0">Add Task</h5> -->
          <div>
            <!--<feather-icon
            class="ml-3 cursor-pointer"
            icon="InfoIcon"
            svgClasses="h-5 w-5 stroke-2"
            
          />-->
            <feather-icon
              class="ml-3 cursor-pointer"
              icon="XIcon"
              svgClasses="h-5 w-5 stroke-2"
              @click="hide"
            />
          </div>
        </div>

        <div class="px-4">
          <!-- Form start -->
          <div>
            <form>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <label class="mt-4 form-label">Form</label>
                  <p>
                    <strong>{{ submission.bookingForm.formName }}</strong>
                  </p>
                  <label class="form-label">Submitted by</label>
                  <p>
                    <code>{{ submission.guestName.trim() }}</code>
                    on {{ submission.venueName }}
                  </p>
                  <label class="form-label">Submitted on</label>
                  <p>
                    {{ submission.date | formatDate }}
                  </p>
                  <label class="form-label" v-if="submission.summary.total > 0"
                    >Total price</label
                  >
                  <p v-if="submission.summary.total > 0">
                    {{ submission.summary.total }}
                    {{ submission.bookingForm.currency }}
                  </p>
                  <vs-divider />
                  <div
                    v-for="(field, idx) in submission.bookingForm.fields"
                    :key="idx"
                  >
                    <label class="form-label">{{ field.label }}</label>
                    <p>
                      {{ field.stringAnswer }}
                    </p>
                  </div>
                  <vs-divider />
                  <vs-row class="flex flex-wrap items-center mt-4 mb-4">
                    <vs-button class="rounded-lg" color="primary" @click="hide"
                      >Close</vs-button
                    >
                  </vs-row>
                  <!-- end  -->
                </div>
              </div>
            </form>
          </div>
          <!-- Form end -->
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      selected: null,

      addDropdownInput: "",
    };
  },
  props: {
    submission: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    ...mapGetters({}),
  },
  methods: {},
  async mounted() {},
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
